<template>
  <div>
    <b-navbar style="background: #fffbfe" toggleable="lg" type="light">
      <b-navbar-brand>
        <b-form-select
          v-if="!loading"
          v-model="selected"
          :options="studySites"
          :style="width < 400 ? 'font-size: 14px' : 'font-size: 18px'"
          class="studySiteSelectorText"
          @change="switchStudySite($event)"
        ></b-form-select>
        <b-spinner v-else type="grow" variant="secondary"></b-spinner>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse">
        <template #default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
          <b-icon v-else icon="chevron-bar-down"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            :active="$route.name.includes('site-summary')"
            :to="{
              name: 'site-summary',
              params: {
                siteId: siteId,
                studyId: studyId,
              },
            }"
            active-class="router-link-exact-active"
            class="navigation-item"
            >Summary
          </b-nav-item>

          <b-nav-item
            :active="$route.name.includes('site-enrollment')"
            :hidden="!canSeeEnrollment"
            :to="{
              name: enrollmentRoute,
              params: {
                siteId: siteId,
                studyId: studyId,
              },
            }"
            active-class="router-link-exact-active"
            class="navigation-item"
            >Enrollment
          </b-nav-item>
          <b-nav-item
            :active="$route.name.includes('start-up-plan')"
            :hidden="!canSeeStartUpPlan"
            :to="{
              name: startUpPlanRoute,
              params: {
                siteId: siteId,
                studyId: studyId,
              },
            }"
            active-class="router-link-exact-active"
            class="navigation-item"
            >Start-Up Plan
          </b-nav-item>

          <b-nav-item
            :active="$route.name.includes('application-access')"
            :hidden="!canSeeApplicationAccess"
            :to="{
              name: applicationAccessRoute,
              params: {
                siteId: siteId,
                studyId: studyId,
              },
              query: {
                option: 'my-access',
              },
            }"
            active-class="router-link-exact-active"
            class="navigation-item"
            >Application Access
          </b-nav-item>
          <b-nav-item
            :active="$route.name.includes('study-site-milestones')"
            :hidden="!canSeeMilestones"
            :to="{
              name: milestoneRoute,
              params: {
                siteId: siteId,
                studyId: studyId,
              },
            }"
            active-class="router-link-exact-active"
            class="navigation-item"
            >Milestones
          </b-nav-item>
          <b-nav-item
            :active="$route.name.includes('system-outage-messages')"
            :hidden="!canSeeSystemOutageMessages"
            :to="{
              name: systemOutageMessagesRoute,
              query: {
                pagination: 'vue',
              },
            }"
            active-class="router-link-exact-active"
            class="navigation-item"
            >System Outage Messages
          </b-nav-item>
          <!-- <b-nav-item
            :active="$route.name.includes('forms')"
            :hidden="!canSeeForms"
            :to="{
              name: 'forms',
            }"
            active-class="router-link-exact-active"
            class="navigation-item"
            >Forms
          </b-nav-item> -->
          <b-nav-item
            v-if="allowStudySubject"
            :active="$route.name.includes('study-subject')"
            :hidden="!haveSubjects"
            :to="{
              name: 'study-subject',
              params: {
                siteId: siteId,
                studyId: studyId,
              },
            }"
            active-class="router-link-exact-active"
            class="navigation-item"
            >Substudy
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
  export default {
    name: 'NavBar',
    props: {
      siteId: String,
      studyId: String,
      user: Object,
      sites: Array,
      blockedModules: Array,
    },
    data() {
      return {
        loading: true,
        selected: '',
        studySites: [],
        width: window.innerWidth,
        responseStudySubjects: [],
      };
    },
    computed: {
      // canSeeForms() {
      //   return (
      //     !this.blockedModules.includes('Forms') &&
      //     this.user.permissions.some(p => p.name === 'access forms')
      //   );
      // },
      allowStudySubject() {
        return window['Laravel']['feature_flags']['study-subject'];
      },
      haveSubjects() {
        return this.responseStudySubjects.length > 0 ? true : false;
      },
      canSeeStartUpPlan() {
        return (
          !this.blockedModules.includes('Start-Up Plan') &&
          this.user.permissions.some(p => p.name === 'access start-up plan')
        );
      },
      canSeeEnrollment() {
        let permissions = ['access my enrollments', 'access enrollment oversight'];
        let modules = ['Enrollment'];

        let isBlockedByStudyModules = this.blockedModules.some(x => modules.includes(x));
        let isBlockedByUserPermissions = !this.user['permissions'].some(x =>
          permissions.includes(x['name']),
        );

        return !isBlockedByStudyModules && !isBlockedByUserPermissions;
      },
      canSeeApplicationAccess() {
        return (
          !this.blockedModules.includes('Application Access') &&
          this.user.permissions.some(p => p.name === 'access application access')
        );
      },
      canSeeMilestones() {
        return (
          !this.blockedModules.includes('Milestones') &&
          this.user.permissions.some(p => p.name === 'access milestones')
        );
      },
      canSeeSubstudy() {
        return (
          !this.blockedModules.includes('Substudy') &&
          this.user.permissions.some(p => p.name === 'access substudy')
        );
      },
      canSeeSystemOutageMessages() {
        return (
          !this.blockedModules.includes('System Outage') &&
          this.user.permissions.some(p => p.name === 'access system outage messages')
        );
      },
      isEnrollmentOversight() {
        return this.$route.name.includes('oversight');
      },
      startUpPlanRoute() {
        if (this.isEnrollmentOversight) {
          return 'oversight-start-up-plan';
        }
        return 'start-up-plan';
      },
      milestoneRoute() {
        if (this.isEnrollmentOversight) {
          return 'oversight-study-site-milestones';
        }
        return 'study-site-milestones';
      },
      applicationAccessRoute() {
        if (this.isEnrollmentOversight) {
          return 'oversight-application-access';
        }
        return 'application-access';
      },
      enrollmentRoute() {
        if (this.isEnrollmentOversight) {
          return 'oversight-site-enrollment';
        }
        return 'site-enrollment';
      },
      systemOutageMessagesRoute() {
        if (this.isEnrollmentOversight) {
          return 'oversight-system-outage-messages';
        }
        return 'system-outage-messages';
      },
    },
    watch: {
      $route() {
        this.updateSelected();
      },
    },
    async created() {
      if (this.allowStudySubject) {
        await this.getAllStudySubjects();
      }
      await this.checkIfUserIsAllowedToSeeStudy();
      window.addEventListener('resize', this.handleResize);
      this.$emit('updateGetStudySites', this.sites);
      let sortedByStudyId = this.sites
        .filter(
          el =>
            el['siteInfo']['siteNumber'] &&
            el['studyInfo']['studyID'] &&
            el['siteInfo']['simplifySiteStatus'],
        )
        .filter(el => {
          const status = el['siteInfo']['simplifySiteStatus']
            ? el['siteInfo']['simplifySiteStatus'].toUpperCase()
            : '';
          return ['SELECTED', 'ONGOING', 'ACTIVATED', 'COMPLETED'].includes(status);
        })
        .sort((a, b) => {
          const studyIdA = a['studyInfo']['studyID'] || '';
          const studyIdB = b['studyInfo']['studyID'] || '';
          return studyIdA.localeCompare(studyIdB);
        });
      this.modifySitesData(sortedByStudyId);
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      async getAllStudySubjects() {
        try {
          let response = await axios.get(
            `/api/get-study-subjects?studyId=${this.studyId}&siteId=${this.siteId}`,
          );
          if (response.status === 200) {
            if (response.data['items'].length > 0) {
              this.responseStudySubjects = response.data['items'];
            } else {
              this.responseStudySubjects = [];
            }
          }
        } catch (error) {
          this.$bvToast.toast(`Server is not responding, please try again later`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
            variant: 'danger',
          });
        }
      },
      async checkIfUserIsAllowedToSeeStudy() {
        const check = this.studyExists(this.studyId);
        if (!check) {
          this.$router.push({ name: 'studies' }).then(r => {
            this.$bvToast.toast(`You do not have access to the requested study (${this.studyId})`, {
              title: `Access Denied`,
              autoHideDelay: 5000,
              appendToast: true,
              variant: 'warning',
              solid: true,
            });
          });
        }
      },
      studyExists(studyId) {
        return this.sites.some(function(el) {
          return el.studyInfo['studyID'] === studyId;
        });
      },
      handleResize() {
        this.width = window.innerWidth;
      },
      switchStudySite(event) {
        let study = event.split('-')[0].trim();
        let site = event.split('-')[1].trim();
        let routeName = this.$route.name;
        this.$router.push({
          name: routeName,
          params: { siteId: site, studyId: study },
          query: this.$route.query,
        });
      },
      modifySitesData(sitesData) {
        sitesData.forEach(element => {
          let studySite = `${element['studyInfo']['studyID']}-${element['siteInfo']['siteNumber']}`;
          if (element['siteInfo']['investigatorName']) {
            studySite = studySite + `-${element['siteInfo']['investigatorName']}`;
          }
          this.studySites.push(studySite);
        });
        this.updateSelected();
        this.loading = false;
      },
      updateSelected() {
        this.selected = this.studySites.find(element =>
          element.includes(this.$route.params['studyId'] + '-' + this.$route.params['siteId']),
        );
      },
    },
  };
</script>

<style scoped>
  .bootstrap-select .btn:focus {
    outline: none !important;
  }

  .studySiteSelectorText {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #4040d7;
    border: 0;
    background-color: #fffbfe;
  }

  .active {
    color: #4040d7 !important;
    border-bottom-color: #4040d7 !important;
    border-bottom-style: inset;
  }
</style>
